import { CREATED, getStatusText } from 'http-status-codes';
import { takeLatest, call, put } from 'redux-saga/effects';

import { actions as couponsActions } from '../details/duck';

import { types, actions } from './duck';
import { applyCoupon, getApplyCoupon } from '../../coupons/api';

export function* applyCouponSaga({ couponId, payByPoints }) {
  try {
    const response = yield call(applyCoupon, couponId, !!payByPoints);

  
    // Update coupon detail state on any response.
    // It will handle cases of 'coupon expiry' or 'coupon was deleted'.
    yield put(couponsActions.getDetail(couponId));

    if (response.status === CREATED) {
      yield put(actions.applyCouponSuccess(couponId, response.data));
    } else if (Array.isArray(response.data)) {
      throw new Error(response.data.join('. '));
    } else if (Array.isArray(response.data.coupon)) {
      throw new Error(response.data.coupon[0]);
    } else {
      throw new Error(getStatusText(response.status));
    }
  } catch (error) {
    console.log('[applyCouponSaga] CAUGHT error, dispatching FAILURE:', error);
    yield put(actions.applyCouponFailure(couponId, error.message));
  }
}

function* getApplyCouponSaga({ couponId, resolve, reject }) {
  try {
    const response = yield call(getApplyCoupon, couponId);
    yield put(actions.getApplyCouponSuccess(couponId, response.data));
    if (resolve) resolve(response.data);
  } catch (error) {
    yield put(actions.getApplyCouponFailure(couponId, error.message));
    if (reject) reject(error.message);
  }
}

export default function* saga() {
  yield takeLatest(types.APPLY_COUPON, applyCouponSaga);
  yield takeLatest(types.GET_APPLY_COUPON, getApplyCouponSaga);
}